
      <div #gmap style=”width:100%;height:400px”>GMAP</div>
  